export const chartsData = [
  {
    "id":1,
    "title": "user interface",
    "value": 72,
    "color":"#9c5da5",
  },{
    "id":2,
    "title": "web design",
    "value": 84,
    "color":"#11b0de"
  },{
    "id":3,
    "title": "wordpress",
    "value": 66,
    "color":"#d67f7f"
  },{
    "id":4,
    "title": "html & css",
    "value": 90,
    "color":"#20bc9d"
  },{
    "id":5,
    "title": "app design",
    "value": 84,
    "color":"#bb8a36"
  },

];




// WEBPACK FOOTER //
// ./src/data/charts.js